// removed by extract-text-webpack-plugin
module.exports = {"contentTab":"_2Twb7rIONG","contentLabel":"_3l5GD1IeyV","dropdownMenu":"ROFEiLRKow","tabTitle":"_1zynSKal8Z","mLeft":"_37i6GpH561"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/EditPage/EditPage.scss
// module id = 909
// module chunks = 0